import Vue from "vue";
import VueRouter from "vue-router";
import Authenticate from "../views/Authenticate";
import Campaigns from "../views/Campaigns";
import Campaign from "../views/Campaign";
import Dashboard from "../views/Dashboard";
import Profil from "../views/Profil";
import Survey from "../views/Survey";
import Results from "../views/Results";
import NProgress from "nprogress";
import {
  getUserProfil,
  getSurvey,
  GetUserCampaigns,
  getSurveyResults,
  GetUserCampaign,
} from "../services/dbService";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Authenticate,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");

      if (user != undefined) {
        var userData = JSON.parse(user);

        if (userData.loggedIn == true) {
          if (userData.is_su == true) {
            next("../campagnes");
          } else {
            next();
          }
          if (userData.is_su == false) {
            next("../dashboard");
          } else {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
  },
  {
    path: "/register",
    name: "register",
    component: Authenticate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");
      routeTo.params.isNewUser = true;
      if (user != undefined) {
        var userData = JSON.parse(user);

        if (userData.loggedIn == true) {
          if (userData.is_su == true) {
            next("../campagnes");
          } else {
            next();
          }
          if (userData.is_su == false) {
            next("../dashboard");
          } else {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
  },
  {
    path: "/lostPassword",
    name: "lostPassword",
    component: Authenticate,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      routeTo.params.isLostPassword = true;
      next();
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/campagnes",
    name: "Campaigns",
    component: Campaigns,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");

      if (user != undefined) {
        var userData = JSON.parse(user);
        if (userData.is_su == true) {
          GetUserCampaigns(userData).then((campaigns) => {
            routeTo.params.campaigns = campaigns;
            next();
          });
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    },
  },
  {
    path: "/campagne/:guid",
    name: "Campaign",
    component: Campaign,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");

      if (user != undefined) {
        var userData = JSON.parse(user);
        if (userData.is_su == true) {
          GetUserCampaign(routeTo.params.guid).then((campaign) => {
            routeTo.params.campaign = campaign;
            next();
          });
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    },
  },
  {
    path: "/",
    name: "Home",
    component: Dashboard,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");
      console.log(routeTo);
      console.log("routeTo");
      console.log(routeFrom);
      console.log("routeFrom");
      if (user != undefined) {
        var userData = JSON.parse(user);

        if (userData.is_su == true) {
          next("../campagnes");
        } else {
          next("/login");
        }
        if (userData.is_su == false) {
          next("../dashboard");
        } else {
          next("/login");
        }
      } else {
        next();
      }
    },
  },
  {
    path: "/profil",
    name: "Profil",
    component: Profil,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      var user = localStorage.getItem("user");

      if (user != undefined) {
        var userData = JSON.parse(user);

        getUserProfil(userData.uid).then((profil) => {
          routeTo.params.profil = profil;

          next();
        });
      }
    },
  },
  {
    path: "/survey/:type",
    name: "Survey",
    component: Survey,
    props: true,
    beforeEnter: (routeTo, routeFrom, next) => {
      var user = localStorage.getItem("user");
      console.log(routeTo + "  routeTo");
      console.log(routeFrom + "  routeFrom");
      if (user != undefined) {
        var userData = JSON.parse(user);
        if (userData.hasSurvey == true && userData.hasResult != true) {
          // get survey from db and load user survey answer into store
          getSurvey(routeTo.params.type).then((surveyData) => {
            routeTo.params.survey = surveyData;

            next();
          });
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    },
  },
  {
    path: "/results",
    name: "Results",
    component: Results,
    props: true,
    beforeEnter: (routeTo, routeFrom, next) => {
      var user = localStorage.getItem("user");
      if (user != undefined) {
        var userData = JSON.parse(user);
        if (userData.hasResult == true) {
          // get survey from db and load user survey answer into store
          getSurveyResults(userData.uid).then((surveyResults) => {
            routeTo.params.results = surveyResults;

            next();
          });
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    },
  },
  {
    path: "*",
    beforeEnter: (routeTo, routeFrom, next) => {
      next("/");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  linkActiveClass: "is-active",
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  // redirect to login page if user is not logged in and trying to access a restricted page
  const publicPages = ["/login", "/register", "/lostPassword"];
  const authRequired = !publicPages.includes(to.path);
  var user = localStorage.getItem("user");

  if (user != undefined) {
    var userData = JSON.parse(user);
    if (userData != null && userData.loggedIn) {
      //   var userData = JSON.parse(loggedIn);
      next();
    } else {
      if (authRequired) {
        NProgress.done();

        return next("/login");
      } else {
        next();
      }
    }
  } else {
    if (authRequired) {
      next("/login");
    } else {
      next();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
